<template>
  <div>
    <div v-if="!page.alreadyRegistratedCompany" class="registrationWrapper company">
      <p-form v-if="!page.registrationSuccess" :model="page.combinedModels" class="registrationForm form">
        <div class="registrierungsCodeWrapper">
          <p-text-field v-model="page.combinedModels.accessToken" :label="$t('page.createCompany.label.externalId')" required></p-text-field>
        </div>
        <div class="companyDetailsWrapper">
          <h3 class="title">
            {{ $t('page.createCompany.title.companyAdress') }}
          </h3>
          <p-text-field v-model="page.combinedModels.company.name" :label="$t('page.createCompany.label.companyName')" required></p-text-field>
          <p-row class="streetWrapper">
            <p-col class="street">
              <p-text-field v-model="page.combinedModels.company.street" :label="$t('page.createCompany.label.companyStreet')" required></p-text-field>
            </p-col>
            <p-col class="houseNumber">
              <p-text-field v-model="page.combinedModels.company.houseNumber" :label="$t('page.createCompany.label.companyHouseNumber')"></p-text-field>
            </p-col>
          </p-row>
          <p-row class="cityWrapper">
            <p-col class="zip">
              <p-text-field v-model="page.combinedModels.company.zip" :label="$t('page.createCompany.label.companyZIP')" required></p-text-field>
            </p-col>
            <p-col class="city">
              <p-text-field v-model="page.combinedModels.company.city" :label="$t('page.createCompany.label.companyCity')" required></p-text-field><br>
            </p-col>
          </p-row>
          <p-file-drop
            v-model="page.logoDocuments"
            class="logo file image"
            :label="$t('page.createCompany.label.LogoDocumentId')"
            max="7"
            accept="image/*"
            single
          ></p-file-drop>
          <p-text-field v-model="page.combinedModels.company.website" :label="$t('page.createCompany.label.website')"></p-text-field>
          <p-textarea v-model="page.combinedModels.company.description" :label="$t('page.createCompany.label.description')"></p-textarea>
          <p-number-field v-model="page.combinedModels.company.employeesCount" :label="$t('page.createCompany.label.employeesCount')"></p-number-field>
          <p-number-field v-model="page.combinedModels.company.apprenticesCount" :label="$t('page.createCompany.label.apprenticesCount')"></p-number-field>
          <p-number-field v-model="page.combinedModels.company.apprenticeShipsCount" :label="$t('page.createCompany.label.apprenticeShipsCount')"></p-number-field>
          <p-select-multiple v-model="page.combinedModels.company.professionIds" :label="$t('page.createCompany.label.jobs')" :items="page.professionItems" required></p-select-multiple>
          <p-location
            v-if="page.newCompany === true"
            :class="{ invalid: page.combinedModels.isDefaultLocation }"
            :set-marker="!page.combinedModels.isDefaultLocation"
            :default-latitude="page.combinedModels.defaultLatitude"
            :default-longitude="page.combinedModels.defaultLongitude"
            @latitudeChange="$set(page.combinedModels.company.location, 'latitude', $event)"
            @longitudeChange="$set(page.combinedModels.company.location, 'longitude', $event)"
          ></p-location>
          <p-location
            v-else
            :default-latitude="page.company.companyLocation.latitude"
            :default-longitude="page.company.companyLocation.longitude"
            @latitudeChange="page.company.companyLocation.latitude = $event"
            @longitudeChange="page.company.companyLocation.longitude = $event"
          ></p-location>
        </div>
        <div class="contactDetailsWrapper">
          <h3 class="title">
            {{ $t('page.createCompany.titel.companyContactDetails') }}
          </h3>
          <p-select v-model="page.combinedModels.company.contact.salutation" :label="$t('page.createCompany.label.companyContactSalutation')" :items="page.genderOptions()" required></p-select>
          <p-text-field v-model="page.combinedModels.company.contact.firstName" :label="$t('page.createCompany.label.companyContactFirstName')" required></p-text-field>
          <p-text-field v-model="page.combinedModels.company.contact.lastName" :label="$t('page.createCompany.label.companyContactLastName')" required></p-text-field>
          <p-phone-field v-model="page.combinedModels.company.contact.phoneNumber" :label="$t('page.createCompany.label.companyContactPhoneNumber')" required></p-phone-field>
          <p-text-field v-model="page.combinedModels.company.contact.email" :label="$t('page.createCompany.label.companyContactEmail')" required type="email"></p-text-field>
        </div>
        <div class="loginWrapper">
          <h3 class="title">
            {{ $t('page.widget.title.createNewUser') }}
          </h3>
          <div v-if="page.newCompany === false">
            <p-radio-field v-model="page.wantsNewUser" :true-value="false" name="wantsNewUser" :label="$t('page.widget.title.wantsNewUser.false', page.userName)"></p-radio-field>
            <p-radio-field v-model="page.wantsNewUser" :true-value="true" name="wantsNewUser" :label="$t('page.widget.title.wantsNewUser.true')"></p-radio-field>
          </div>
          <div v-if="page.newCompany === true || (page.newCompany === false && page.wantsNewUser === true)">
            <p-text-field v-model="page.combinedModels.user.email" :placeholder="page.newCompany === true ? page.combinedModels.company.contact.email : ''" :label="$t('page.widget.label.userEmail')" required></p-text-field>
            <p-text-field v-model="page.combinedModels.user.password" :label="$t('page.widget.label.userPassword')" required type="password"></p-text-field>
            <p-text-field v-model="page.combinedModels.user.repeatPassword" :label="$t('page.widget.label.userSecondPassword')" type="password" required></p-text-field>
          </div>
        </div>
        <div class="checkboxenWrapper">
          <p-checkbox v-model="page.combinedModels.company.acceptConditions" :label="$tEnum('page.createCompany.label.acceptConditions', 'no_html')" required>
            <span v-html="$tEnum('page.createCompany.label.acceptConditions', 'html')"></span>
          </p-checkbox>
        </div>
      </p-form>
      <p-row v-if="!page.registrationSuccess" class="saveButton">
        <p-button :disabled="page.isLoading" :loading="page.isLoading" @click="page.saveNewCompanies()">
          {{ $t('core.app.save') }}
        </p-button>
      </p-row>
      <p-request-alert v-if="!page.registrationSuccess" v-model="page.convertedError"></p-request-alert>
    </div>
    <div v-else class="alreadyRegistratedCompanyWrapper">
      <p-row class="alreadyRegistratedCompanyAlert">
        <div>
          <p-alert :value="true" type="info">
            <span v-html="$t('page.companies.alert.alreadyRegistratedCompany', [page.eventName], [page.userName])"></span>
          </p-alert>
        </div>
      </p-row>
      <p-row class="alreadyRegistratedCompanyButton">
        <div>
          <a :href="$config.values['dashboard-link']" :link="true" target="_blank" rel="noopener noreferrer">
            <p-button>
              {{ $t('page.widget.button.redirectToIL') }}
            </p-button>
          </a>
        </div>
      </p-row>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import CompanyRegistrationPage from './registration.vue.model';

  export default Vue.extend({
    name: 'CompanyRegistration',
    layout: 'layout-widget',
    data: () => ({
      page: new CompanyRegistrationPage(),
    }),
    async beforeMount() {
      const queries = this.$routerUtils.getQueryParams();
      // Due to difference in casing (email vs. query param) we need to check two versions
      const accessToken = queries.accesstoken ?? queries.accessToken;
      if (accessToken) {
        this.page.combinedModels!.accessToken = accessToken;
      }
      await this.page.initialize();
    },
  });
</script>
